/**
 * HarvestInspectionsExportAllDropdownItem
 */
import React from 'react';
import { connect } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';

// Actions
import { requestExportReportsHarvestInspectionsAll } from '../../../../../../../../services/reportsHarvestInspectionsAll/actions';

interface Props {
    requestExportReportsHarvestInspectionsAll: Function;
}

export class HarvestInspectionsExportAllDropdownItem extends React.PureComponent<Props> {
    handleClick = () => {
        this.props.requestExportReportsHarvestInspectionsAll();
    };

    render() {
        return (
            <Dropdown.Item text="Harvest Quality" onClick={this.handleClick} />
        );
    }
}

export default connect(
    null,
    { requestExportReportsHarvestInspectionsAll }
)(HarvestInspectionsExportAllDropdownItem);
